<template>
  <div class="bOrderInfos">
    <div class="bOrderInfos__container container pt-4">
      <div class="bOrderInfos__header row">
        <div class="bOrderInfos__header__h2 h2 col">購物指南</div>
      </div>
      <div class="bOrderInfos__body d-flex flex-column align-items-center">
        <form class="w-100 pb-3"
        @submit.prevent="add_new_ois">
            <b-button
            v-b-toggle="'newOis'"
            class="btn-info m-1 w-100 d-flex flex-column align-items-center">
              新增購物指南
            </b-button>
            <b-collapse id="newOis">
              <b-card class="p-1">
                <div class="form-group d-flex justify-content-end">
                  <button class="btn btn-info mr-3"
                  type="submit">
                    新增購物指南
                  </button>
                  <button class="btn btn-danger"
                  @click.prevent="create_new_ois">
                    清除重填
                  </button>
                </div>
                <div class="form-group">
                  <label>標題</label>
                  <input type="text"
                  class="form-control"
                  v-model="newOis.title"
                  required>
                </div>
                <div class="form-group">
                  <label>內容</label>
                  <textarea class="form-control"
                  rows="3" v-model="newOis.content"
                  required
                  ></textarea>
                </div>
              </b-card>
            </b-collapse>
        </form>
        <form class="w-100 pb-3"
        v-for="(item, index) in ois"
        :key="index"
        @submit.prevent="edit_ois(item)">
            <b-button
            v-b-toggle="`ois${index}`"
            class="m-1 w-100 d-flex flex-column align-items-center">
              <span>{{item.title}}</span>
            </b-button>
            <b-collapse :id="`ois${index}`">
              <b-card class="p-1">
                <div class="form-group d-flex justify-content-end">
                  <button class="btn btn-info mr-3"
                  type="submit">
                    儲存變更
                  </button>
                  <button class="btn btn-danger"
                  @click.prevent="delete_ois(item.id)">
                    刪除
                  </button>
                </div>
                <div class="form-group">
                  <label>標題</label>
                  <input type="text"
                  class="form-control"
                  v-model="item.title"
                  required>
                </div>
                <div class="form-group">
                  <label>內容</label>
                  <textarea class="form-control"
                  rows="10" v-model="item.content"
                  required></textarea>
                </div>
              </b-card>
            </b-collapse>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      ois: [],
      newOis: {},
    };
  },
  methods: {
    initialize_ois() {
      let ois;
      this.$bus.$on('son_get_data', (data) => {
        ois = JSON.parse(JSON.stringify(data.orderInfos));
      });
      this.$bus.$emit('son_call_data');
      this.ois = ois;
    },
    create_new_ois() {
      this.newOis = {
        title: '',
        content: '',
      };
      const oisLength = this.ois.length;
      this.newOis.index = `ois${oisLength + 1}`;
    },
    add_new_ois() {
      this.$bus.$emit('add_new_ois', this.newOis);
      this.initialize_ois();
      this.create_new_ois();
    },
    edit_ois(oisObj) {
      this.$bus.$emit('edit_ois', oisObj);
      this.initialize_ois();
    },
    delete_ois(oisId) {
      this.$bus.$emit('delete_ois', oisId);
      this.initialize_ois();
    },
  },
  created() {
    this.initialize_ois();
    this.create_new_ois();
  },
};
</script>
